module.exports = __webpack_public_path__ + "img/CLVHelp4.96eb4ce9.png";